import { observable } from "mobx";
import AccountingDocumentsInventoryCreationActionRejectionReason from "./accountingDocumentsInventoryCreationActionRejectionReason";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class AccountingDocumentsInventoryCreationActionResponse {
  @observable
  isAllowed!: boolean;

  @observable
  requiredAccountingPeriodFrom?: string;

  @observable
  latestAccountingPeriodTo?: string;

  @observable
  rejectionReason?: AccountingDocumentsInventoryCreationActionRejectionReason;
}
